import React from "react";
import { usePage } from "@brz-utils/contexts/page.context";



export const FAQSchema = () => {
    const { page, template } = usePage();

    if (page.seo.faq?.disable || template.disable?.faqSchema || !page.seo.faq?.items?.length) return null;

    const jsonObj = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "name": page.seo.faq.name,
        "mainEntity": page.seo.faq.items.map((item) => {
            return {
                "@type": "Question",
                "name": item.q,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": item.a
                }
            }
        })
    };

    return (
        <script id="faq-schema" type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonObj, null, '  ') }} />
    );
};